import React from 'react';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';

interface WizardStepNavigationProps {
  currentStep: number;
  totalSteps: number;
}

export const WizardStepNavigation: React.FC<WizardStepNavigationProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <>
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-900">建立婚禮邀請函</h2>
          <span className="text-sm text-gray-500">步驟 {currentStep} / {totalSteps}</span>
        </div>
        <div className="flex items-center">
          {Array.from({ length: totalSteps }, (_, i) => (
            <div key={i} className="flex items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                i + 1 <= currentStep
                  ? 'bg-pink-500 text-white'
                  : 'bg-gray-200 text-gray-600'
              }`}>
                {i + 1 <= currentStep ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              {i < totalSteps - 1 && (
                <div className={`w-12 h-1 mx-2 ${
                  i + 1 < currentStep ? 'bg-pink-500' : 'bg-gray-200'
                }`} />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

interface WizardNavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  canProceed: boolean;
  isGenerating: boolean;
  onBack: () => void;
  onNext: () => void;
  isFirstStep: boolean;
}

export const WizardNavigationButtons: React.FC<WizardNavigationButtonsProps> = ({
  currentStep,
  totalSteps,
  canProceed,
  isGenerating,
  onBack,
  onNext,
  isFirstStep,
}) => {
  return (
    <div className="flex justify-between">
      <button
        onClick={onBack}
        className="flex items-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        {isFirstStep ? '返回首頁' : '上一步'}
      </button>
      <button
        onClick={onNext}
        disabled={!canProceed || isGenerating}
        className="flex items-center px-6 py-3 bg-pink-500 text-white rounded-lg hover:bg-pink-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {currentStep === totalSteps ? (
          isGenerating ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              生成中...
            </>
          ) : (
            '完成建立'
          )
        ) : (
          <>
            下一步
            <ArrowRight className="h-4 w-4 ml-2" />
          </>
        )}
      </button>
    </div>
  );
};
